const utmKeys = ['utm_campaign', 'utm_source', 'utm_medium', 'utm_term', 'utm_content'];
const params = new URLSearchParams(window.location.search);
utmKeys.forEach(k => {
  const v = params.get(k);
  if (v && !sessionStorage.getItem(k)) sessionStorage.setItem(k, v);
});
